<template>
  <section>
    <div class="mgt-24 pdb-17 shadow-bottom" v-if="missionNotice">
      <div class="d-flex mgl-8 mgr-8">
        <div class="w-40 mgl-8 mgr-8">
          <img src="@/assets/banner_alarm_icon.svg" alt="" />
        </div>
        <div class="t-body2 mgl-8 mgr-8 align-self-center">
          <!-- 새로 업데이트된 내용을 확인하세요. -->
          {{ $t("199") }}
        </div>
      </div>
    </div>

    <div class="pda-default">
      <!-- <no-data v-if="!missionsList.length && dataLoadState"></no-data> -->
      <div class="mgt-16" v-if="!missionsList.length && dataLoadState">
        <div
          class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pdt-24 pdb-20"
        >
          <div class="d-flex justify-content-center flex-column">
            <div class="t-center">
              <img
                src="images/no-data2.svg"
                alt=""
                class="w-44 h-44 mgx-auto"
              />
            </div>
            <div
              class="t-color-content1 t-body3 l-spacing42 t-center mgt-24 font-r"
            >
              {{ $t("1965") }}
            </div>
          </div>
        </div>
      </div>

      <div class="mdc-card mdc-elevation--z3" v-if="missionsList.length">
        <div class="t-subtitle2 mgt-16 mgb-16 mgl-16 mgr-16">
          {{ $t("200") }}
          <!-- 과제 -->
        </div>

        <div v-for="(mission, index) in missionsList" :key="index">
          <div class="ripple-item pdb-16">
            <div
              class="d-flex flex-row justify-content-between pdt-12 mgl-8 mgr-8"
              @click="moveMission(mission)"
            >
              <div class="pdl-8 pdr-8">
                <img src="@/assets/mission_icon.svg" alt="" />
              </div>
              <div class="pdl-8 pdr-8 flex-grow-1">
                <div class="t-body1">
                  {{ mission.name }}
                  <div class="t-body3 t-color-gray2">
                    <!-- {{mission.status}} -->
                    <div v-if="mission.status === 'WAITING'">
                      {{ $t("205") }}
                      <!-- 제출 불가 -->
                    </div>
                    <div v-else-if="mission.status === 'SUBMISSIBLE'">
                      <!-- {{$t('201')}} -->
                      <!-- 미제출 -->
                    </div>
                    <div v-else-if="mission.status === 'SUBMITTED'">
                      {{ $t("201") }}
                      <!-- 제출됨 -->
                    </div>
                    <div v-else-if="mission.status === 'UNDER_EVALUATION'">
                      {{ $t("203") }}
                      <!-- 평가 진행 중 -->
                    </div>
                    <div v-else-if="mission.status === 'EVALUATED'">
                      {{ $t("206") }}
                      <!-- 평가 완료 -->
                    </div>
                    <div v-else-if="mission.status === 'TERMINATION'">
                      {{ $t("TODO-종료") }}
                      <!-- 종료 -->
                    </div>
                    <div
                      class="mission-reject-box d-inline-block mgt-4"
                      v-else-if="mission.status === 'REJECT'"
                    >
                      <img
                        src="@/assets/mission_error_icon.svg"
                        class="w-13 h-12 d-inline-block"
                      />
                      <span class="mgl-4 mgr-4">
                        {{ $t("204") }}
                        <!-- 과제물 반려 -->
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex flex-row-reverse mgr-16 mgl-16">
              <span>{{ mission.feedbackCount }}</span>
              <div class="position-relative">
                <div class="w-16 h-16 mgr-4 mgl-4">
                  <img src="@/assets/mission_feedback_icon.svg" class="" />
                </div>
                <div class="dot" v-if="mission.feedbackUnread"></div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-row" v-if="missionsList.length > index + 1">
            <div class="mgl-16 mgr-16 w-40"></div>
            <div class="flex-grow-1">
              <hr class="divider" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
/**
 * 나의 학습 상세 미션정보
 *
 * @author minkyoung.park@emcast.com
 * @author
 * @since 2019.07
 */

// Components/Mixin/Extend/API 선언
import httpService from "@/api/httpService";
import learnApi from "@/api/learnApi.js";
import NoData from "../../common/NoData.vue";
import { MDCRipple } from "@material/ripple";
import { log } from "util";
export default {
  components: {
    "no-data": NoData,
  },
  data() {
    return {
      missionsData: null,
      missionsList: [],
      dataLoadState: false,
      missionNotice: false,
    };
  },
  mounted() {
    this.fetchData();
  },

  updated() {
    const ripples = [].map.call(
      document.querySelectorAll(".ripple-item"),
      function (el) {
        let ripple = new MDCRipple.attachTo(el);
        return ripple;
      }
    );
  },

  watch: {
    $route(to, from) {
      console.log("경로 변경이닷! fetchData");
      this.fetchData();
    },
  },

  methods: {
    // 미션정보 API 호출 및 데이터 설정
    fetchData() {
      let responseData = null;
      let params = this.setParams();

      this.$showLoading(this.$refs.missionList);
      learnApi
        .learnViewMission(params)
        .then((response) => {
          this.missionsList = response.data.data;
          // if (this.missionsData) {
          //     this.assignmentsList = this.missionsData.assignments
          // }
          console.log("missionsList", this.missionsList);
          this.$hideLoading();
          this.dataLoadState = true;

          let submissibleList = _.filter(this.missionsList, function (o) {
            return o.status === "SUBMITTED" || o.status === "SUBMISSIBLE";
          });

          if (submissibleList) {
            let missionId = _.head(submissibleList).id;
            this.setMissionId(missionId);
          }
        })
        .catch((err) => {});

      learnApi
        .learnViewMissionNotice(params)
        .then((response) => {
          this.missionNotice = response.data.data;
        })
        .catch((err) => {});
    },

    // 파라미터 설정
    setParams() {
      const params = {
        learnId: this.$route.params.learnId,
      };
      return params;
    },

    moveMission(mission) {
      console.log(mission);
      this.$router.push({
        name: "LearnViewMission",
        params: {
          assignmentId: mission.id,
        },
        query: this.$route.query,
      });
    },

    setMissionId(missionId) {
      this.$emit("setMissionId", missionId);
    },
  },
};
</script>

<style scopped>
</style>
